import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  hoverable = true, 
  selected = false,
  onClick 
}) => {
  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick?.()}
      className={`
        bg-white rounded-2xl shadow-sm border transition-all duration-200 overflow-hidden
        ${hoverable ? "hover:shadow-lg hover:border-blue-300 cursor-pointer" : ""}
        ${selected ? "ring-2 ring-blue-500 border-blue-400 bg-blue-50/40" : "border-slate-200"}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;